import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { takeUntil } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { format } from 'support';

import { PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { MealPlan, MealPlanData, ProgramTemplateData } from 'app/@core/interfaces/common/CalorieFriend/plan';
import { UsersService } from 'app/@core/backend/common/services/users.service';
import { NativeAppService } from 'app/@core/backend/common/services/native-app.service';

import { MealPlanDefComponentBase } from 'app/pages/CalorieFriend/Plans/PlanDef/plan-def-base.component';

@Component({
  selector: 'patient-meal-plan-view',
  templateUrl: './patient-meal-plan-view.component.html',
  styleUrls: ['./patient-meal-plan-view.component.scss'],
})
export class PatientMealPlanViewComponent
  extends MealPlanDefComponentBase
  implements OnInit {
  @ViewChild('PlanSelection') PlanSelection: any;

  IsMobile: boolean = false;
  TheDayLabel = $localize`:@@Day:Day`;

  constructor(
    private PlanViewPatientsService: PatientData,
    private deviceService: DeviceDetectorService,
    private PlanViewRoute: ActivatedRoute,
    PlanViewFormBuilder: FormBuilder,
    PlanViewDialogService: NbDialogService,
    private PlanViewPlanService: MealPlanData,
    PlanViewToasterService: NbToastrService,
    PlanViewUsersService: UsersService,
    PlanViewRouter: Router,
    public nativeAppService: NativeAppService,
    programTemplateService: ProgramTemplateData,
  ) {
    super(
      PlanViewRoute,
      PlanViewFormBuilder,
      PlanViewDialogService,
      PlanViewPlanService,
      PlanViewToasterService,
      PlanViewUsersService,
      PlanViewRouter,
      PlanViewPatientsService,
      programTemplateService
    );
    this.PlanView = true;
    this.ref = null;
  }

  ngOnInit(): void {

    super.ngOnInit();

    this.PlanViewPlanService.get(this.PlanID).subscribe((data) => {

    },
      (err) => {
        let plansList;
        plansList = this.PlanViewPlanService.listByGuid(
          this.NotificationToken
        );
        plansList.subscribe((data) => {
          let plans = data.items;
          let newId = '';
          const activePlan: MealPlan = plans.find((plan) => plan.active);

          if (activePlan) {
            newId = activePlan.id.toString();
          } else {
            if (plansList.length > 0) {
              plans.sort((p1, p2) => p2.id - p1.id);
              newId = plans[0].id;
            }
          }

          if (newId !== '') {
            window.location.href = `/PatientView/Patient/${this.NotificationToken}/Meal/${newId}`;
          } else {
            window.location.href = `/PatientView/calendar/${this.NotificationToken}`;
          }
        });
      });

    //super.ngOnInit();

    this.onResize();

    if (this.PatientID || this.NotificationToken) {
      console.log("Plandef", this.PatientID);
      this.PlanViewPatientsService.get(this.PatientID, this.NotificationToken)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((patient) => {
          this.PatientName = format(
            "{0} {1}'s View",
            patient.firstName,
            patient.lastName
          );
        });
    }

    if (this.NotificationToken) {
      const Elements = document.getElementsByClassName('header-container');
      if (Elements?.length > 0) {
        const container: any = Elements[0];
        const Header = container.parentElement.parentElement.parentElement;
        Header.style.visibility = 'hidden';
        Header.style.height = '0px';
      }
    }
  }

  showMobileAppAdvert() {
    if (this.nativeAppService.isFromApp()) return false;
    if (this.deviceService.isDesktop) return false;

    if (this.deviceService.os) return false;

    return true;
  }

  onResize() {
    // check if running mobile
    this.IsMobile = this.deviceService.isMobile();
  }

  DayOrderName(day) {
    return format('{0} {1} ({2})', this.TheDayLabel, day.order, day.name);
  }
}
